import { createDbWorker } from 'sql.js-httpvfs';

export default defineNuxtPlugin(async () => {
  const workerUrl = new URL('sql.js-httpvfs/dist-out/sqlite.worker.js', import.meta.url);
  const wasmUrl = new URL('sql.js-httpvfs/dist-out/sql-wasm.wasm', import.meta.url);

  return {
    provide: {
      createSqlWorker: createDbWorker,
      sqlWorkerUrl: workerUrl,
      sqlWasmUrl: wasmUrl,
    },
  };
});
